export default __webpack_public_path__ + "static/media/cloud.c8c8b219.svg";